<form class="document" [formGroup]="formGroup">
    <div class="document-row">
        <div class="document-info">
            <h3 class="bold document-title">{{ this.addRequiredAsterisk(fieldSchema) }}</h3>
            <span class="remove document-action-icon" *ngIf="!hasDocumentFields && adminMode">
                <lsq-icon
                    class="remove-document"
                    (click)="openModalRemoveDocument()"
                    [type]="icons.FaTrashAlt"
                    [color]="color.Black"
                ></lsq-icon>
            </span>
            <span class="edit document-action-icon" *ngIf="adminMode">
                <lsq-icon
                    class="edit-document"
                    (click)="handleEditDocument()"
                    [type]="icons.FaEdit"
                    [color]="color.Black"
                ></lsq-icon>
            </span>
            <br />
            <span class="document-description">
                {{ fieldOption.copy }}
            </span>
            <br />
            <div class="request-details" *ngIf="showRequestDetails">
                <span>Requested </span>
                <span *ngIf="!!fieldOption?.requestedBy">by {{ fieldOption.requestedBy }} </span>
                <span *ngIf="!!fieldOption?.requestedAt"
                    >at {{ fieldOption.requestedAt | date : dateFormat.LsqShortYear }}
                </span>
            </div>
        </div>
        <div class="document-buttons" *ngIf="!processing">
            <lsq-button
                [style.display]="'block'"
                [appearance]="'secondary'"
                [size]="'sm'"
                (buttonClick)="handleUploadDocument()"
                *ngIf="showSubmitButtons"
            >
                Upload Document
            </lsq-button>
            <lsq-button
                [style.display]="'block'"
                [style.margin-left]="'2rem'"
                [appearance]="'secondary'"
                [size]="'sm'"
                (buttonClick)="handleAcceptDocument()"
                *ngIf="showAcceptButton"
            >
                Archive
            </lsq-button>
        </div>
        <lsq-circle-loader *ngIf="processing" class="processing-loader"></lsq-circle-loader>
    </div>
    <hr class="double-hr provide-doc-hr" />
    <span class="document-error" *ngIf="validateDocumentField()"
        >Please provide the requested document.</span
    >
    <div *ngIf="hasDocumentFields">
        <div class="provide-doc" *ngFor="let doc of documents">
            <div class="documents">
                <a (click)="this.downloadDocument(doc)" class="file-field document-file-name">
                    <lsq-smart-truncate
                        [value]="doc.fileName"
                        [popoverValue]="doc.fileName"
                    ></lsq-smart-truncate>
                </a>
                <span [style.margin-right]="'1rem'"> Submitted at: </span>
                <lsq-smart-truncate
                    class="file-field submitted-date"
                    [value]="doc.uploadedDate | date : dateFormat.LongTime"
                    [popoverValue]="
                        'Submitted at ' + (doc.uploadedDate | date : dateFormat.LongTime)
                    "
                ></lsq-smart-truncate>
                <div *ngIf="doc.asOfDate" class="date-range">
                    <span> As of date: </span>
                    <lsq-smart-truncate
                        class="file-field as-of-date"
                        [value]="doc.asOfDate | date : dateFormat.LsqShortYear"
                        [popoverValue]="
                            'Valid as of date: ' + (doc.asOfDate | date : dateFormat.LongTime)
                        "
                    ></lsq-smart-truncate>
                    <span *ngIf="doc.endDate"> to </span>
                    <lsq-smart-truncate
                        *ngIf="doc.endDate"
                        class="file-field end-date"
                        [value]="doc.endDate | date : dateFormat.LsqShortYear"
                        [popoverValue]="'End date: ' + (doc.endDate | date : dateFormat.LongTime)"
                    ></lsq-smart-truncate>
                </div>
                <lsq-smart-truncate
                    [ngClass]="{
                        'document-notes-short': doc.asOfDate || schemaType === 'Prospect',
                        'document-notes': !doc.asOfDate
                    }"
                    class="file-field"
                    [value]="doc.documentNotes"
                    [popoverValue]="doc.documentNotes"
                ></lsq-smart-truncate>
            </div>
            <div class="remove" *ngIf="showSubmitButtons">
                <lsq-icon
                    class="remove-document"
                    (click)="openModalRemoveFile(doc, fieldSchema.label)"
                    [type]="icons.FaTrashAlt"
                    [color]="color.Green"
                ></lsq-icon>
            </div>
        </div>
    </div>
    <hr *ngIf="hasDocumentFields" class="double-hr provide-doc-hr" />
    <div *ngIf="hasPendingUploads">
        <div class="provide-doc" *ngFor="let upload of pendingUploads">
            <div class="documents">
                <div class="file-field document-file-name">
                    <lsq-smart-truncate
                        [value]="upload.name"
                        [popoverValue]="upload.name"
                    ></lsq-smart-truncate>
                </div>
                <span class="progress-info">
                    <span [style.margin-right]="'1rem'"> Upload in progress... </span>
                    <lsq-progress-bar
                        class="upload-progress-bar"
                        [value]="upload.progress"
                        [skinny]="true"
                    >
                    </lsq-progress-bar>
                </span>
            </div>
            <div class="remove">
                <lsq-icon
                    class="remove-pending-document"
                    (click)="removePendingUpload(upload.name)"
                    [type]="icons.Close"
                    [color]="color.Green"
                    [width]="18"
                ></lsq-icon>
            </div>
        </div>
    </div>
    <hr *ngIf="hasPendingUploads" class="double-hr provide-doc-hr" />
</form>
